import React from 'react';
import { Field } from 'react-form';
import InfoButton from '../../InfoButton';
import { checkProfanity } from '../../../utils/validation';
import { getLangFile } from '../../../api/profanityFilterApi';

class Input extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            words: null,
        };
    }

    componentDidMount() {
        this.remoteRequest();
    }

    // eslint-disable-next-line consistent-return
    validate = (text) => {
        if (this.props.disableProfanityCheck) {
            if (this.props.validate) {
                return this.props.validate(text);
            }
        } else {
            if (this.props.validate) {
                return checkProfanity(text, this.state.words) || this.props.validate(text);
            }
            return checkProfanity(text, this.state.words);
        }
    }

    async remoteRequest() {
        try {
            await getLangFile()
                .then(res => res.json())
                .then(data => {
                    this.setState({ words: data });
                });
        } catch (e) {
            console.log(e);
        }
    }

    render() {
        return (
            <Field field={this.props.field} validate={this.validate} asyncValidate={this.props.asyncValidate}>

                {(fieldApi) => {
                    const { onChange, onBlur, onPaste, onKeyDown, field, validate, asyncValidate, inputWrapperStyle, id, label, inputStyle, placeholder, hiddenLabel, description, asyncErrors, children, formGroupCssClass, hoverText, disabled, ...rest } = this.props;
                    const { value, error, warning, touched, setValue, setTouched } = fieldApi;

                    const displayError = error || (asyncErrors && asyncErrors.answer);

                    const inputProps = {
                        ...rest,
                        id,
                        className: `form-control`,
                        style: inputStyle,
                        value: value || '',
                        placeholder,
                        onChange: e => {
                            setValue(e.target.value);
                            if (onChange) {
                                onChange(e.target.value, e);
                            }
                        },
                        onBlur: e => {
                            setTouched();
                            if (onBlur) {
                                onBlur(e);
                            }
                        },
                        onPaste: e => {
                            if (onPaste) {
                                onPaste(e.target.value, e);
                            }
                        },
                        onKeyDown: e => {
                            if (onPaste) {
                                onKeyDown(e.target.value, e);
                            }
                        },
                    };

                    return (
                        <div className={`${formGroupCssClass} ${(touched && displayError) && 'is-invalid'} ${description && 'description'}  ${this.props.type === 'hidden' ? 'd-none' : ''}`}>
                            <label htmlFor={id} className={hiddenLabel ? 'sr-only' : ''}>
                                {label}
                                {hoverText && <InfoButton hoverText={hoverText} />}
                            </label>
                            {description && (<small>{description}</small>)}
                            <div className={`input-wrapper ${inputWrapperStyle}`}>
                                <input {...inputProps} disabled={disabled} />
                                {children}
                                <div className="error-indicator" />

                            </div>
                            {touched &&
                                ((displayError && <div className="invalid-feedback">{displayError}</div>) ||
                                (warning && <div className="warning-feedback">{warning}</div>))}

                        </div>
                    );
                }}
            </Field>
        );
    }
}

export default Input;
